import { gql } from '@apollo/client';

export const UPDATE_DAILY_REPORT_SUBSCRIPTION = gql`
  mutation UpdateDailyReportSubscription(
    $siteId: Int!
    $userId: Int!
    $isSubscribed: Boolean!
  ) {
    updateDailyReportSubscription(
      siteId: $siteId
      userId: $userId
      isSubscribed: $isSubscribed
    )
  }
`;
